<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >顯示順序</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field   v-model="displaySeq"  type="number"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >主Key</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field   v-model="code"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >科別簡介維護(代號)</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field  v-model="value1"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >科別名稱</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field  v-model="value2"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >科別代號(His)</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field  v-model="value3"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >院區代號</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-select
                                    v-if="this.zoneNameList.length>0"
                                    v-model="value4"
                                    hide-details
                                    :items="zoneNameList"
                                    :item-text="zoneItemText"
                                    item-value="zone"
                            ></v-select>
                            <v-text-field v-else v-model="value4"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >備註</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="memo"  v-model="memo"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "EditISelfDivSetting",
        props:['editIndex','isShow','editObj','zoneNameList'],
        data() {
            return {
                displaySeq:0,//顯示順序
                groupId:'SELFDIV',//群組ID
                code:'',//代號
                value1:'',//值1
                value2:'',//值2
                value3:'',//值3
                value4:'',//值4
                memo:'',//說明
                modifyObj:{},
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){
                    this.displaySeq = this.editObj.displaySeq==undefined?'':this.editObj.displaySeq;
                    this.groupId = 'SELFDIV'
                    this.code = this.editObj.code==undefined?'':this.editObj.code;
                    this.value1 = this.editObj.value1==undefined?'':this.editObj.value1;
                    this.value2 = this.editObj.value2==undefined?'':this.editObj.value2;
                    this.value3 = this.editObj.value3==undefined?'':this.editObj.value3;
                    this.value4 = this.editObj.value4==undefined?'':this.editObj.value4;
                    this.memo = this.editObj.memo==undefined?'':this.editObj.memo;


                }else {
                    this.displaySeq =0;
                    this.groupId = 'SELFDIV';
                    this.code = '';
                    this.value1 = '';
                    this.value2 = '';
                    this.value3 = '';
                    this.value4 = 'A';
                    this.memo = '';
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 自定義科別' : '編輯 自定義科別'
            },
        },
        methods:{
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                if(this.editIndex==-1){ //新增狀態
                    this.modifyObj = {
                        displaySeq : this.displaySeq==''||this.displaySeq==null||this.displaySeq==undefined?0:this.displaySeq,
                        groupId : this.groupId,
                        code : this.code ,
                        value1: this.value1,
                        value2 : this.value2,
                        value3 : this.value3,
                        value4 : this.value4,
                        memo: this.memo,
                        rawPk:'',

                    }
                }else { //修改狀態
                    this.modifyObj = {
                        displaySeq : this.displaySeq==''||this.displaySeq==null||this.displaySeq==undefined?0:this.displaySeq,
                        groupId : this.groupId,
                        code : this.code ,
                        value1: this.value1,
                        value2 : this.value2,
                        value3 : this.value3,
                        value4 : this.value4,
                        memo: this.memo,
                        rawPk: this.editObj.rawPk,



                    }
                }
                // parseFloat(this.sortByNo).toFixed(1);
                if(this.groupId==''||this.code==null){
                    alert('請輸入群組ID 和 代號')
                }else {
                    this.$emit('save',this.modifyObj);
                }

            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>